import React, { useContext, useState } from 'react';
import { Container, Row, Col, Form } from "react-bootstrap";
import AuthContext from '../../auth/authContext';
import style from "./myProfile.module.scss"
import UsersService from "../../HttpService/UsersService";
import { ERoles } from '../../.config';

const TODIS_PROFILE = () => {
    const { user } = useContext(AuthContext);
    //console.log("Info: ", user);
    const [allowEmails, setAllowEmails] = useState(user.allowNotifications);

    const handleAllowEmailsChange = async () => {
        const newAllowEmails = !allowEmails;
        setAllowEmails(newAllowEmails);

        await new UsersService().changeAllowNotifications(user.id, newAllowEmails);

    };

    const handleRoles = user.roles.map(role => ERoles[role] ? ERoles[role].label : role.name);

    return (
        <Container fluid className="todis-form-wrapper p-4">
            <Row>
                <Col>
                    <h1 className="todis-header text-center">User Profile</h1>
                </Col>
            </Row>
            <Row className="task-att py-3">
                <Col sm={2} className={style.title}><strong>Username:</strong></Col>
                <Col sm={10}>{user.username}</Col>
            </Row>
            <Row className="task-att py-3">
                <Col sm={2} className={style.title}><strong>Email:</strong></Col>
                <Col sm={10}>{user.email}</Col>
            </Row>
            <Row className="task-att py-3">
                <Col sm={2} className={style.title}><strong>Roles:</strong></Col>
                <Col sm={10}>{handleRoles.join(", ")}</Col>
            </Row>
            <Row className="task-att py-3">
                <Col sm={2} className={style.title}><strong>Regional Partners:</strong></Col>
                <Col sm={10}>
                    <ul>
                        {user.regionalPartner.map((partner) => (
                            <li key={partner.id}>
                                {partner.name} - {partner.countrycode}
                            </li>
                        ))}
                    </ul>
                </Col>
            </Row>
            <Row className="task-att">
                <Col sm={2} className={style.title}><strong>Permissions:</strong></Col>
            </Row>
            <Row className="task-att">
                {user.permissions.map((permissionGroup, index, array) => (
                    <Col
                        key={permissionGroup.id}
                        sm={4}
                        className={`text-center py-3 ${index === array.length - 1 && array.length === 7 ? "mx-auto" : ""}`}
                    >
                        <strong>{permissionGroup.name}</strong>
                        {permissionGroup.permissions.map((permission) => (
                            <li key={permission.id} className="text-center">
                                {permission.name}
                            </li>
                        ))}
                    </Col>
                ))}
            </Row>
            <Row className="task-att py-3">
                <Col sm={2} className={style.title}><strong>Allow notifications by Email:</strong></Col>
                <Col sm={10}>
                    <Form.Check
                        type="switch"
                        id="allowEmailsSwitch"
                        label={allowEmails ? "Yes" : "No"}
                        checked={allowEmails}
                        onChange={handleAllowEmailsChange}
                    />
                </Col>
            </Row>
        </Container>
    )
}

export default TODIS_PROFILE;